import { useEffect } from 'react';
import { Notification } from '@/components/Notification/Notification';
import { RevealAccessType } from '@/types/myVaultTypes';

const COPY: Record<Exclude<RevealAccessType['reason'], ''>, string> = {
  verified:
    'Your identity is verified and these instructions are shown once. Copy or save them now: reloading or closing this page makes the link unavailable.',
  one_time:
    'This is a one-time link. Copy or save the instructions now: reloading or closing this page makes the link unavailable.',
};

/**
 * Shown above the revealed instructions when the server says the view is the only one.
 * Also asks the browser to confirm a reload or close while it is mounted.
 */
export const SingleViewNotice = ({ access }: { access: RevealAccessType }) => {
  const show = access.single_view && access.reason !== '';

  useEffect(() => {
    if (!show) return;

    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = ''; // required by Chrome for the confirm dialog
    };

    window.addEventListener('beforeunload', warn);

    return () => window.removeEventListener('beforeunload', warn);
  }, [show]);

  if (!show) return null;

  return <Notification variant='warning'>{COPY[access.reason as keyof typeof COPY]}</Notification>;
};
